const mod = require('webfontloader')

module.exports = mod
